// extracted by mini-css-extract-plugin
export default {"showMoreIconButton":"styles_showMoreIconButton__S+v6A","text":"styles_text__7lflI","addIcon":"styles_addIcon__cg6BY","buttonLoader":"styles_buttonLoader__QrYdD"};